module.exports = __webpack_public_path__ + "img/splash.a873146a.png";